import { EinzaApiService } from "@/services/einzaApi"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryAllMixCollections = {
  async allMixCollections(parent, args, context, info) {
    try {
      const dataResponse = await EinzaApiService.getData("kollektionen/findAll")

      const { user } = context

      await checkPermissions({
        user,
        domainObject: DomainObjects.MIXED_PRODUCTS,
        operation: Operations.READ,
      })

      if (dataResponse?.data && dataResponse?.data.length >= 1) {
        const { data } = dataResponse

        return {
          total: data.length,
          items: data.map((mixCollection) => {
            return {
              description: mixCollection.bezeichnung,
              sysId: mixCollection.sysId,
            }
          }),
        }
      }

      return null
    } catch (err) {
      throw new Error(err)
    }
  },
}
